import {randomFromArray} from '../../../helpers/random-from-array.js'
import range from 'lodash/range'
import BattleActions from '../../battle-data/battle-actions.js'
import listingTextHelper from '../../../helpers/listing-text-helper.js'

export function getStealingChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Set up for modification
  let changes = {
    ...currentCombatantStateChanges
  };

  //Remember, at this point in the DescriptionCycle, we know the attack has not failed.
  //Therefore, we can assume that the enemy has items.
  if (action.theftQuantity > 0 || action.deleteItemQuantity > 0) {

    const casterModel = combatantModels[combatantMap.casterId];
    const targetModels = combatantMap.targetIds.map(combId => combatantModels[combId]);

    //Construct a list of Target Team models with references back to the individual owner
    let targetItemModels = [];
    targetModels.forEach(targetModel => {
      targetModel.items.forEach(itemModel => {
        targetItemModels.push({
          model: itemModel,
          belongsToCombatantId: targetModel.id
        })
      });
    });

    //Decide which quantity to use (will only be one or the other.)
    //Both would be a config error.
    const quantity = action.theftQuantity > 0 ? action.theftQuantity : action.deleteItemQuantity;
    //Note^^ This is pretty coupled to TWO possible options. If a third option is ever present here, may need to rework this.


    //Gather up the item(s) that we're stealing (or deleting)
    let stolenItems = [];
    range(quantity).forEach(() => {
      const stolenItem = randomFromArray(targetItemModels);
      if (stolenItem) {
        targetItemModels = targetItemModels.filter(itemModel => {
          return itemModel.model.instanceId !== stolenItem.model.instanceId
        });
        stolenItems.push(stolenItem);
      }
    });

    //If we're in "stealing" mode (not deleting), add these stolen items to our Caster
    if (action.theftQuantity > 0) {
      //Apply these items to the caster.
      const existingCasterStateChanges = changes.state[combatantMap.casterId] || {};
      changes.state[combatantMap.casterId] = {
        ...existingCasterStateChanges,
        items: [
          ...casterModel.items,
          ...stolenItems.map(itemModelWithRef => {
            return {
              ...itemModelWithRef.model, //Shave off the `belongsToCombatantId part`
              isStolen: true, //Note that this item is now stolen
              isBugged: false //Clear any bug status that this item has
            }
          })
        ]
      };
    }

    //Remove each stolenItem from original owner.
    stolenItems.forEach(stolenItemModel => {
      const ownerCombModel = combatantModels[stolenItemModel.belongsToCombatantId];

      //Filter out stolen item from owner's list of items.
      const items = changes.state[stolenItemModel.belongsToCombatantId].items || ownerCombModel.items; //check for existing items in changes first
      const updatedOwnerItems = items.filter(inventoryItemModel => {
        return stolenItemModel.model.instanceId !== inventoryItemModel.instanceId
      });

      //Apply reduced items list to owner
      const existingOwnerChanges = changes.state[stolenItemModel.belongsToCombatantId];
      changes.state[stolenItemModel.belongsToCombatantId] = {
        ...existingOwnerChanges,
        items: updatedOwnerItems.length ? updatedOwnerItems : false //stub `false` for empty array because of silly Firebase.
      }
    });

    //Create the keys for our description object. Note that we're still pretty married to only two cases here: theftQuantity or deleting
    const affectedItemIdsKeyName = action.theftQuantity > 0 ? "stolenItemIds" : "deletedItemIds";
    const affectedItemFriendlyTextKeyName = action.theftQuantity > 0 ? "stolenItemsFriendlyText" : "deletedItemsFriendlyText";

    //Mark the stolenIds. These are used for Reporting!
    changes.description[affectedItemIdsKeyName] = stolenItems.map(item => item.model.actionId);

    //Create the human readable item text for the Rollout.
    changes.description[affectedItemFriendlyTextKeyName] = listingTextHelper(
      stolenItems.map(item => item.model.actionId).map(actionId => BattleActions[actionId].name)
    );


    //Add itemModel data if this was a stealAndUse kind of action
    if (action.stealAndUseItem) {
      changes.description["stealAndUseItems"] = [
        ...stolenItems.map(itemModelWithRef => {
          return {
            ...itemModelWithRef.model, //Shave off the `belongsToCombatantId part`
          }
        })
      ]
    }

  }

  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/stealing.js